const sanitize = (value?: string) => value?.replace(/\/+$/, '');

export const env = {
  apiBaseUrl: sanitize(import.meta.env.VITE_API_BASE_URL),
  subscriptionApiUrl: sanitize(import.meta.env.VITE_SUBSCRIPTION_API_URL),
  /**
   * The public website, for the sales pitch: the portal opens its builder and
   * shares the /for/<shop> links it produces. Falls back to production so the
   * column works before the variable is set anywhere.
   */
  siteUrl: sanitize(import.meta.env.VITE_SITE_URL) || 'https://www.localfirst.co.in',
};
